import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setSlackAiBlocked = {
  name: "setSlackAiBlocked" as const,
  input: z.object({ teamId: zExt.objectId(), blocked: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
